/**
 * Copyright © 2026 Adnuntius AS.
 */

import * as _ from 'lodash';

import {interpolateTemplate} from '../../filters/interpolate-template';

function marketplaceWording(text: string, isPureMarketplace?: boolean): string {
  return isPureMarketplace
    ? text.replace('earnings account', 'publisher').replace('Earnings Account', 'Publisher')
    : text;
}

export const interpolateWarning = function(warning: any, isPureMarketplace?: boolean): string {
  const warningText = _.get(warning, ['text'], warning);
  const text = interpolateTemplate(warningText)(warning.parameters);
  return marketplaceWording(text, isPureMarketplace);
};

export const apiInterpolate = function(warning: any, isPureMarketplace?: boolean): string {
  const warningText = _.get(warning, ['text'], warning);
  const text = interpolateTemplate(warningText)(warning.parameters);
  return marketplaceWording(text, isPureMarketplace);
};
